import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";
import { STARTING_PAGE, PAGE_SIZE } from "./../reducers/hallsList.reducer";
import { hallsStoreSelectors } from "../store/store";

function* createHall(action) {
    try {
        const hall = yield call(() =>
            hallsAPI.createHall({ ...action.payload })
        );

        yield put({
            type: HallsActionTypes.CREATE_HALL_SUCCESS,
            payload: hall.data
        });

        ToasterService.successToast("Hall successfully created.");

        yield put({
            type: HallsActionTypes.GET_HALLS_LIST,
            payload: {
                page: STARTING_PAGE,
                top: PAGE_SIZE,
                filters: hallsStoreSelectors.filters()
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error creating hall.");

        yield put({
            type: HallsActionTypes.CREATE_HALL_FAIL,
            message: e.message
        });
    }
}

export function* createHallWatcher() {
    yield takeLatest(HallsActionTypes.CREATE_HALL, createHall);
}
